import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import DropDownButtonUI from "./DropDownButtonUI";
import ColorPickerDynamic from "../../../UI/ColorPicker/ColorPickerDynamic";
import { Palette } from "lucide-react";

const ItemTextDecorationUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
  const [items ,setItems] =useState(itemsArray);
  
  const [palletDecorationColorBG, setPalletDecorationColorBG] = useState(false);
  const [resolution, setPxPercent] = useState(objectValue?objectValue?.thickness?.resolution:'px');
 const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [itemValue, setItemValue] = useState(objectValue);

 return(<>


                                    <div  style={{display:"flex",justifyContent:"space-between"}}>
                                              
          <div style={{display:"flex",justifyContent:"space-between"}}>
                                                    <div><DropDownButtonUI activeCard={""} icon={2} title={objectValue.line} 
                                                     onClickSendObject={(value)=>{if(value){callbackItemValue(value,`${objectName}DecorationLine`)}}}
                                                      hasDropDown={true} dropDownObject={[{title:"None",value:"none"},{title:"Below Text",value:"underline"},{title:"Above Text",value:"overline"},
                                                        {title:"Middle ",value:"line-through"},{title:"Above & Below",value:"underline overline"},
                                                      ]} /> </div> <div><DropDownButtonUI activeCard={""} icon={2} title={objectValue.style} 
                                                     onClickSendObject={(value)=>{if(value){callbackItemValue(value,`${objectName}DecorationStyle`)}}}
                                                      hasDropDown={true} dropDownObject={[{title:"Straight",value:"solid"},{title:"Dotted",value:"dotted"},{title:"Dashed",value:"dashed"},
                                                        {title:"Double",value:"double"},{title:"Wavy",value:"wavy"}
                                                      ]} /> </div> 
                       
                        </div> </div>
<div style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"10px",}}>
       
               
             <div className="" style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginBottom:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        
                      
            
                        <div style={{display:"flex",justifyContent:"space-around"}}><h4>Line Thickness </h4>
                        <div style={{display:"flex",justifyContent:"space-around"}}>
            <RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
              setItemValue({value:val,resolution:resolution});
              callbackItemValue({value:val,resolution:resolution},`${objectName}DecorationThickness`)}} 
               sliderVal={objectValue.thickness?.value} />
              <div style={{height:"50px" ,width:"90px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  
                         
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} >
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                          %
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={resolution=="%"?"yes":""}
                   className="input-textbox"  value="%"  name={objectName+"px"}  
                   onChange={e=>{setPxPercent("%")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            px                        
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={resolution=="px"?"yes":""}
                   className="input-textbox"  value="px"  name={objectName+"px"}   
                   onChange={e=>{setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div></div></div>
                         <label onMouseEnter={
                                                                                    ()=>handleMouseEnter("#fff","#333","")}
                                                                     onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{background:objectValue.decorationColor?.color,height:"25px",marginTop:"5px"}}>
                                                                                   <div style={{display:"flex",justifyContent:"space-between"}} >
                                                                                   
                                                                                    <Palette onMouseEnter={handleMouseEnter}
                                                                                                            onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                                            
                                                                                    </div> 
                                                                     <input type="checkbox" title="Color Theme"   checked={palletDecorationColorBG?"yes":""}
                                                          className="input-textbox"  value={palletDecorationColorBG}  name="palletDecorationColorBG1"  
                                                          onChange={e=>{setPalletDecorationColorBG(e.target.checked)}}/>
                                                               <span class={"boxCardBorder-two"}></span> </label>
                        
                        
                        
                       
               </div> 
               
 {palletDecorationColorBG?<>
                         <div style={{}}><ColorPickerDynamic activeColorPickerValue={objectValue.decorationColor?.color} setActiveColorPickerValue={(color)=>{
                        callbackItemValue(color,`${objectName}DecorationColor`);}} colorPickerOptionArray={[]}   palletTitle={objectValue.decorationColor?.title} /> 
                        </div></>:"" }
                                                    </div>
                                                    </div>

                                                  
                                 </>)

    } 
    export default ItemTextDecorationUI;

                     

